const BASE_URL = {
    production: "https://api.mookie.app",
    staging: "https://api-test.mookie.app",
    dev: "https://api-test.mookie.app",
};
  
export default BASE_URL;